<template>
    <div>
        <button @click="showModal" class="callback_button">
            <span class="callback_circle">
                <span class="callback_pulse pulse animated infinite"></span>
                <span class="callback_zoomout zoomOut animated infinite"></span>
                <span class="callback_image">
                    <svg class="svg-icon">
                        <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#phone_callback"></use>
                    </svg>
                </span>
            </span>
            <span class="callback_text">{{ Lang.get('js.callback') }}</span>
        </button>
        <div v-show="show" class="blocker">
            <div id="callback-popup" class="modal callback_modal">
                <div class="callback_wrap">
                    <div @click="hideModal" class="callback_modal_close">
                        <span class="close thick"></span>
                    </div>
                    <div class="callback_form">
                        <div id="form-callback" :class="{'error': !validNumber }">
                            <div class="intl-tel-input allow-dropdown separate-dial-code">
                                <input name="phone"
                                       type="tel"
                                       id="js-phone"
                                       placeholder=""
                                       autocomplete="off"
                                       v-model="phone"
                                       @input="keepOnlyNumbers">
                            </div>
                            <button @click="callMe" class="callback_submit">{{ Lang.get('js.call_me') }}</button>
                        </div>
                    </div>
                    <div class="circle_container">
                        <div id="container_around"></div>
                    </div>
                    <div class="callback_notification">
                        <div class="callback_notification_text">
                            <span class="callback_notification_color">Thank you</span> for contacting us
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    // https://github.com/jackocnr/intl-tel-input
    import intlTelInput from 'intl-tel-input';

    window.intlTelInput = intlTelInput;

    export default {
        name: "callbackForm",
        props: {
            countryCode: {
                type: String,
                default: 'US'
            },
        },
        data() {
            return {
                show: false,
                phone: '',
                iti: null,
                validNumber: true,
                Lang,
            }
        },
        watch: {
            phone: function (newVal, oldVal) {
                if (!this.validNumber) {
                    this.clearErrors();
                }
            }
        },
        methods: {
            showModal() {
                if (this.iti === null) {
                    this.setIpInfo();
                }

                this.show = true;
            },
            hideModal() {
                this.show = false;
                this.clearErrors();
            },
            clearForm() {
                this.phone = '';
                this.clearErrors();
            },
            callMe() {
                if (this.iti.isValidNumber()) {
                    let data = {
                        'country_code': this.iti.getSelectedCountryData().iso2,
                        'phone_number': this.iti.getNumber().replace('+', ''),
                    };

                    axios.post('/site/callback', data).then(res => {
                        this.hideModal();
                        this.clearForm();
                    }).catch(error => {
                        Sentry.captureException(error);
                    });
                } else {
                    this.validNumber = false;
                }
            },
            keepOnlyNumbers() {
                this.phone = this.phone.replace(/\D+/g, '');
            },
            setIpInfo() {
                let input = document.getElementById('js-phone');
                let countryCode = this.countryCode;

                this.iti = intlTelInput(input, {
                    utilsScript: '/js/utils.js',
                    separateDialCode: true,
                    initialCountry: 'auto',
                    geoIpLookup: function (callback) {
                        localStorage.setItem('countryCode', countryCode)
                        return callback(countryCode);
                    }
                });
            },
            clearErrors() {
                this.validNumber = true;
            }
        },
        mounted() {
            this.setIpInfo();
        }
    }
</script>
